import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 5rem 0rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  max-width: 200px;
  height: 200px;
  object-fit: contain;
`;
